<template>
    <SearchObject
        :additional-params="{ ordering: 'name', ...additionalParams }"
        :allow-create="allowCreate"
        :autofocus="autofocus"
        :base-url="baseUrl"
        :create-label="$translate('create_a_product')"
        :disabled="disabled"
        :hide-details="hideDetails"
        :error-messages="errorMessages"
        :item-text="itemText"
        :hide-label="hideLabel"
        :placeholder="resolvedPlaceholder"
        :label="hideLabel ? '' : (label || $translate('select_product'))"
        :readonly="readonly"
        :required="required"
        :value="value"
        :initial-item="initialItem"
        @create="createProduct"
        @input="$emit('input', $event)"
        @select="$emit('select', $event)"
            ref="search"
        :dense="dense"
        :outlined="outlined"
    >
        <template slot="item" slot-scope="{ item }">
          <div>
            <div v-if="displayOwner && item.owner_data && item.owner_data.name" class="text-caption text--secondary">{{ item.owner_data.name }}</div>
            <ProductName
                class="my-1 text-body-3"
                type="providerproduct"
                :product="item"
                :display-code="true"
                :inline-code="true"
            />
          </div>
        </template>
    </SearchObject>
</template>

<script>
import EditProduct from "@/modals/product";
import GlobalMixins from "@/mixins/global";

export default {
    mixins: [GlobalMixins],
    props: {
        displayOwner: { type: Boolean, default: false },
        // The base URL to fetch items from.
        baseUrl: {
            type: String,
            default: "/api/products/",
        },
        // Additional GET parameters to include in the API request.
        additionalParams: {
            type: Object,
            default: () => ({}),
        },
        // Whether the component is disabled.
        disabled: {
            type: Boolean,
            default: false,
        },
        // v-model binding (selected item ID).
        value: {
            type: [String, Number],
            default: null,
        },
        initialItem: {
            type: Object,
            default: null,
        },
        // Label for the autocomplete.
        label: {
            type: String,
            default: "",
        },
        // Optional limit per request.
        limit: {
            type: Number,
            default: 20,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        allowCreate: {
            type: Boolean,
            default: false,
        },
        hideDetails: {
            type: [Boolean, String],
            default: false,
        },
        errorMessages: {
            type: Array,
            default: () => [],
        },
        dense: {
            type: Boolean,
            default: false,
        },
        outlined: {
            type: Boolean,
            default: false,
        },
        hideLabel: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: "",
        },
    },
    computed: {
        resolvedPlaceholder() {
            if (this.placeholder) {
                return this.placeholder;
            }
            if (this.hideLabel) {
                return this.$translate("select_product");
            }
            return "";
        },
    },
    methods: {
        async createProduct() {
            const result = await this.showModal({
                component: EditProduct,
                params: {
                    product: {},
                },
            });
            if (result) {
                this.$emit("input", result);
                this.$refs.search.update();
            } else {
                this.$refs.search.reset();
            }
        },

        itemText(item) {
            let text = `${item.upc} - ${item.name}`;
            if (item.description) {
                text += ` - ${item.description}`;
            }
            if (this.displayOwner && item.owner_data && item.owner_data.name) text = `${item.owner_data.name} · ${text}`;
            return text;
        },
        focus() {
            this.$refs.search.focus();
        },
    },
    i18n: {
        messages: {
            en: {
                select_product: "Select a product",
                create_a_product: "Create a product",
            },
            fr: {
                select_product: "Sélectionnez un produit",
                create_a_product: "Créer un produit",
            },
        },
    },
};
</script>
